import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var FailedDeliveryAttempt = function FailedDeliveryAttempt() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ObOGqM",
    defaultMessage: "When a delivery attempt fails, it\u2019s essential to act quickly to address the situation and ensure your shipment reaches the retailer successfully. Here\u2019s what you can do:"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Dk6+pO",
    defaultMessage: "<BoldFormatting>Contact the carrier:</BoldFormatting> Reach out to the carrier immediately to understand the reason for the failed delivery attempt and discuss the possibility of re-attempting the delivery.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fHRo9Q",
    defaultMessage: "<BoldFormatting>Message your retailer:</BoldFormatting> Inform the retailer about the failed delivery attempt and any updates or changes that might affect the delivery timeline.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "v4mWlX",
    defaultMessage: "<BoldFormatting>Verify the shipping address:</BoldFormatting> Double-check the shipping address provided by the retailer. If there are any discrepancies, confirm the correct address with the retailer.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "/2TRVS",
    defaultMessage: "<BoldFormatting>Arrange for redelivery:</BoldFormatting> Once the address is confirmed and any issues are resolved, coordinate with the carrier to schedule a redelivery at the earliest convenience.",
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};